import * as React from 'react';
import '../css/collaged-image-content.sass';
import ProgrammingLockup, { ProgramDetail } from './ProgrammingLockup';
import { ImageDetail } from './StackedImageContent';

interface CollagedImageContentProps {
  images: ImageDetail[];
  alignment?: 'left' | 'right';
}

const programmingDetail = (detail: ProgramDetail) => {
  return (
    <ProgrammingLockup
      transparent
      details={[
        {
          pkgName: detail.pkgName,
          pkgImgUrl: detail.pkgImgUrl,
          showName: detail.showName
        }
      ]}
    />
  );
};

export default function CollagedImageContent(props: CollagedImageContentProps) {
  const { alignment = 'left' } = props;
  let keyIndex = 0;
  const className = (imgCount: number) => {
    let val = '';
    if (imgCount === 1) {
      val = ' single';
    } else if (imgCount === 2) {
      val = ' double';
    } else if (imgCount === 3) {
      val = ' triple';
    }
    return val;
  };
  return (
    <>
      <div
        className={`collaged-image-content${className(
          props.images.length
        )} ${alignment}`}
      >
        {props.images.map((image: ImageDetail) => {
          keyIndex += 1;
          return (
            <div
              className="image-container"
              key={`${image.url.toLowerCase().replace(' ', '')}${keyIndex}`}
            >
              <img
                className="main-img"
                src={image.url}
                alt={image.alt}
                key={image.url}
              />
              <div className="details-mobile">
                {image.detail && programmingDetail(image.detail)}
              </div>
            </div>
          );
        })}
        <div className="details-desktop">
          {props.images.map((image: ImageDetail) => {
            keyIndex += 1;
            return (
              <React.Fragment
                key={`${image.url.toUpperCase().replace(' ', '')}${keyIndex}`}
              >
                {image.detail && <>{programmingDetail(image.detail)}</>}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
}
